import { createSlice } from '@reduxjs/toolkit';
import { IFilterItem } from '../../search-desktop/interfaces';

interface IState {
    query: string;
    filtered: IFilterItem[];
    selectedItemIndex: number;
    isOpened: boolean;
    touched: boolean;
}

/**
 * initial state
 */
const initialState: IState = {
    query: '',
    selectedItemIndex: -1,
    filtered: [],
    isOpened: false,
    touched: false,
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },
    }
});

export default rootSlice;